import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Bootstrap estaba importado pero no se usaba ni una clase suya: el proyecto
// entero está hecho con Tailwind. Y hacía daño: su regla `body { ... }` venía
// después de la nuestra y le pisaba el fondo (lo dejaba blanco) y la tipografía
// (la volvía a la del sistema). Se ve cuando el contenido se sale del wrapper
// .App, o cuando el rebote del scroll deja ver el body.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
